import * as React from "react";
import Alert from "@mui/material/Alert";
import AlertTitle from "@mui/material/AlertTitle";
import Link from "@mui/material/Link";

const TITLE = "We're moving to an upgraded platform.";
const EMAIL = "Operations@finvolve.co";
const DESCRIPTION = (
  <>
    Data here may not reflect current values. Everything will be refreshed when
    the new platform goes live in the coming days. For any information, please
    write to <Link href={`mailto:${EMAIL}`}>{EMAIL}</Link>
  </>
);

// part: "title" (login pages), "description" (dashboards), "both" (home)
export default function RevampBanner({ part = "both", sx }) {
  const showTitle = part !== "description";
  const showDescription = part !== "title";
  return (
    <Alert severity="info" sx={{ width: "100%", ...sx }}>
      {showTitle &&
        (showDescription ? (
          <AlertTitle sx={{ fontWeight: 600 }}>{TITLE}</AlertTitle>
        ) : (
          <strong>{TITLE}</strong>
        ))}
      {showDescription && DESCRIPTION}
    </Alert>
  );
}
